import * as Constants from '../../utils/constants';

export const submitFeedback = (payload: any, callback?: Function) => ({
    type: Constants.SUBMIT_FEEDBACK,
    payload: {
        data: payload,
        callback
    }
})

export const getSubmitFeedback = (payload: any) => ({
    type: Constants.GET_SUBMIT_FEEDBACK,
    payload
})
